import React, { Component } from 'react';

import { USER_ROLE_ADMIN } from 'common/userRoles';

import { SCREEN_ID_ADMIN_ORDERS_OVERVIEW } from 'client/constants/screenIds';
import branch from 'client/core/branch';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScrollToTop from 'client/helpers/withScrollToTop';
import withScreenId from 'client/helpers/withScreenId';
import allowedRoles from 'client/helpers/allowedRoles';

import SrPartnerPageV2 from 'client/components/SrPartnerPageV2/SrPartnerPageV2';
import SrSunSetupOrdersOverview from 'client/components/SrSunSetupOrdersOverview/SrSunSetupOrdersOverview';
import DriverActions from 'client/actions/Driver';

@withTransitionHook
@allowedRoles({
  roles: [
    USER_ROLE_ADMIN,
  ],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_ADMIN_ORDERS_OVERVIEW)
@branch({
  driversByMarketId: ['drivers', 'byMarketId'],
})
@withScrollToTop
class AdminOrdersOverviewPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Setup Orders',
    section: 'Admin',
  });

  static fetchData(state, inject) {
    const currentUser = inject.state.get(['currentUser']);
    const isAdmin = currentUser.roles.includes(USER_ROLE_ADMIN);
    const promisesToResolve = [];
    if (isAdmin) {
      promisesToResolve.push(DriverActions.getDriverList(inject));
    }
    return Promise.all(promisesToResolve);
  }

  render() {

    const { driversByMarketId } = this.props;

    return (
      <SrPartnerPageV2
        navbarTitle='SunSetup'
      >
        <SrSunSetupOrdersOverview
          driversByMarketId={driversByMarketId}
        />
      </SrPartnerPageV2>
    );
  }
}

AdminOrdersOverviewPage.displayName = 'AdminOrdersOverviewPage';

export default AdminOrdersOverviewPage;
